{
  "user": {
    "title": "Dashboard",
    "greeting": "Welcome back",
    "greetingNamed": "Welcome back, {{name}}",
    "description": "Jump to a setting or pick up where you left off.",
    "quickActions": "Quick actions",
    "accountTitle": "Account",
    "accountDescription": "Update your profile and personal details.",
    "securityTitle": "Security",
    "securityDescription": "Manage your password and two-factor authentication.",
    "notificationsTitle": "Notifications",
    "notificationsDescription": "Choose how and when we reach you.",
    "activityTitle": "Recent activity",
    "activityEmptyTitle": "No recent activity",
    "activityEmptyDescription": "Your recent account activity will appear here."
  },
  "admin": {
    "title": "Admin overview",
    "greeting": "Welcome back",
    "greetingNamed": "Welcome back, {{name}}",
    "description": "Platform administration at a glance.",
    "quickActions": "Manage",
    "usersTitle": "Users",
    "usersDescription": "View, invite, and manage platform users.",
    "tenantsTitle": "Tenants",
    "tenantsDescription": "Configure tenants and their branding.",
    "analyticsTitle": "Analytics",
    "analyticsDescription": "Track usage and platform metrics.",
    "siteTitle": "Site",
    "siteDescription": "Edit and publish the marketing site.",
    "featureFlagsTitle": "Feature flags",
    "featureFlagsDescription": "Roll features out across tenants and users.",
    "pluginsTitle": "Plugins",
    "pluginsDescription": "Manage installed plugins and availability."
  },
  "metrics": {
    "heading": "Overview",
    "chartsHeading": "Activity",
    "totalUsers": "Total users",
    "apiUsage": "API requests",
    "errorRate": "Error rate",
    "errorRateElevated": "Above the expected threshold",
    "growth": "New users",
    "featureUsage": "Feature usage",
    "attention": "Attention",
    "apiUsageChart": "API requests by route",
    "featureUsageChart": "Feature usage",
    "chartEmpty": "No data for this range"
  },
  "range": {
    "label": "Time range",
    "24h": "Last 24 hours",
    "24h_short": "24h",
    "7d": "Last 7 days",
    "7d_short": "7d",
    "30d": "Last 30 days",
    "30d_short": "30d"
  },
  "state": {
    "loading": "Loading dashboard metrics",
    "emptyTitle": "No analytics yet",
    "emptyBody": "Metrics will appear here as people use your app.",
    "errorTitle": "We couldn't load your metrics",
    "errorBody": "Something went wrong loading your dashboard metrics. Please try again.",
    "retry": "Try again"
  }
}
